import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { request } from "@/lib/http";

export type LoginStat = { n: string; l: string };

export type BrandingOut = {
  brand_name: string;
  logo_url: string | null;
  favicon_url: string | null;
  primary_color: string;
  pwa_short_name: string;
  login_tagline: string | null;
  login_headline: string | null;
  login_subtitle: string | null;
  login_stats: LoginStat[];
  login_compliance: string | null;
  login_register_tagline: string | null;
};

const FALLBACK: BrandingOut = {
  brand_name: "TrendMonitor",
  logo_url: null,
  favicon_url: null,
  primary_color: "#2563EB",
  pwa_short_name: "TrendMonitor",
  login_tagline: "Inteligencia social para equipos",
  login_headline: "Escucha lo que se dice de tu marca, responde antes que se viralice.",
  login_subtitle: "Monitoriza menciones, automatiza respuestas y mide impacto en redes sociales y medios digitales — todo desde una sola consola.",
  login_stats: [
    { n: "14M+", l: "menciones / mes" },
    { n: "32", l: "fuentes integradas" },
    { n: "99.9%", l: "uptime" },
  ],
  login_compliance: "SOC 2 Type II · GDPR · ISO 27001",
  login_register_tagline: "14 días de prueba — sin tarjeta de crédito",
};

export function useBranding() {
  const query = useQuery({
    queryKey: ["branding"],
    queryFn: () => request<BrandingOut>("/branding"),
    staleTime: 5 * 60_000,
    placeholderData: FALLBACK,
  });
  return query.data ?? FALLBACK;
}

export function useApplyBranding() {
  const branding = useBranding();
  useEffect(() => {
    document.title = branding.brand_name;
    document.documentElement.style.setProperty("--brand-primary", branding.primary_color);
    if (branding.favicon_url) {
      let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = branding.favicon_url;
    }
  }, [branding.brand_name, branding.primary_color, branding.favicon_url]);
}
